<template>
  <v-dialog v-model="mensajeActivo" persistent max-width="400">
    <v-card class="mx-auto" :color="mensajeColor" dark>
      <v-card-title>
        <v-icon large left>{{ mensajeIcono }}</v-icon>
        <span class="display-1 font-weight-thin">{{ tituloIcono }}</span>
      </v-card-title>
      <v-card-text>
        <h3 class="title mb-3">{{ mensajeTitulo }}</h3>
        {{ detalle }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <template v-if="tipo.startsWith('Confirmacion')">
          <v-btn small text rounded @click="ejecutarAccion('Cancelar')">
            Cancelar
            <v-icon right>clear</v-icon>
          </v-btn>
          <v-btn
            small
            outlined
            rounded
            @click="ejecutarAccion('Aceptar')"
            @keyup.enter="ejecutarAccion('Aceptar')"
          >
            Aceptar
            <v-icon right>check</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-btn small outlined rounded @click="ejecutarAccion('Cancelar')">
            Cerrar
            <v-icon right>clear</v-icon>
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Mensaje",
  props: ["activo", "tipo", "titulo", "detalle"],
  data() {
    return {
      mensajeActivo: false,
      mensajeColor: "",
      mensajeIcono: "",
      tituloIcono: "",
      mensajeTitulo: ""
    };
  },
  watch: {
    activo() {
      this.mensajeActivo = this.activo;
    },
    tipo() {
      switch (this.buscarTipo(this.tipo)) {
        case "Guardar":
          this.mensajeColor = "primary";
          this.mensajeIcono = "help_outline";
          this.tituloIcono = "Consulta";
          this.mensajeTitulo = "¿Quiere guardar los cambios?";
          break;
        case "Borrar":
          this.mensajeColor = "red darken-4";
          this.mensajeIcono = "help_outline";
          this.tituloIcono = "Atención";
          this.mensajeTitulo = "¿Quiere borrar el item seleccionado?";
          break;
        case "Error":
          this.mensajeColor = "red";
          this.mensajeIcono = "error_outline";
          this.tituloIcono = "Importante";
          this.mensajeTitulo = "Se ha producido un error";
          break;
        default:
          this.mensajeColor = "blue-grey darken-1";
          this.mensajeIcono = "notifications_none";
          this.tituloIcono = "Aviso";
          this.mensajeTitulo = "Atención";
          break;
      }
    },
    titulo() {
      if (this.titulo != null) this.mensajeTitulo = this.titulo;
    }
  },
  methods: {
    ejecutarAccion(accion) {
      this.$emit("ejecutarAccion", accion + this.tipo);
    },
    buscarTipo(tipo) {
      let res = "Aviso";
      if (tipo.includes("Guardar")) res = "Guardar";
      if (tipo.includes("Borrar")) res = "Borrar";
      if (tipo.includes("Error")) res = "Error";
      return res;
    }
  }
};
</script>
